import React from "react";
import { Link } from "react-router-dom";
import { UserSquare2 } from "lucide-react";
import { useResellerLookup } from "../../lib/resellerIndex";

// Lien « Voir le compte » vers la fiche revendeur (bloc Compte client).
export const AccountLink = ({ resellerId, distributorId, children, compact = false, testid }) => {
  const lookup = useResellerLookup();
  const rid = lookup(resellerId, distributorId);
  if (!rid) return children || null;
  return (
    <span className="inline-flex items-center gap-1.5">
      {children}
      <Link
        to={`/revendeurs/${rid}#compte`}
        onClick={(e) => e.stopPropagation()}
        className="inline-flex items-center gap-0.5 text-[11px] text-[#1F4E3D] hover:underline whitespace-nowrap"
        title="Voir le compte client"
        data-testid={testid || `account-link-${rid}`}
      >
        <UserSquare2 className="w-3.5 h-3.5" />
        {!compact && "Voir le compte"}
      </Link>
    </span>
  );
};

export default AccountLink;
